var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ADB5BD",
    fillRule: "evenodd",
    d: "M10,2.5 C12.3011865,2.5 14.1666667,4.36548021 14.1666667,6.66666667 L14.1663333,8.333 L15,8.33333333 C15.9204746,8.33333333 16.6666667,9.07952542 16.6666667,10 L16.6666667,15 C16.6666667,15.9204746 15.9204746,16.6666667 15,16.6666667 L5,16.6666667 C4.07952542,16.6666667 3.33333333,15.9204746 3.33333333,15 L3.33333333,10 C3.33333333,9.07952542 4.07952542,8.33333333 5,8.33333333 L5.83333333,8.333 L5.83333333,6.66666667 C5.83333333,4.36548021 7.69881354,2.5 10,2.5 Z M10,4.16666667 C8.61928813,4.16666667 7.5,5.28595479 7.5,6.66666667 L7.5,6.66666667 L7.5,8.33333333 L12.5,8.33333333 L12.5,6.66666667 C12.5,5.28595479 11.3807119,4.16666667 10,4.16666667 Z",
    transform: "translate(-3 -2)"
  })));
};
export default SvgLock;